<template>
  <el-card>
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$root.state.facility" :to="{ name: 'Facility Pricing', params: { facility: $root.state.facility } }">{{String($root.state.facilityData.code).toUpperCase()}} Pricing</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ name: 'Facilities' }">Pricing</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-tabs v-model="activeTab">
      <el-tab-pane v-if="this.selectedFacility.pricing" name="facility" label="Single Location">
        <el-tabs type="border-card" tab-position="top" v-model="pricingTab" stretch>
          <el-tab-pane label="Warehouse" name="warehouse">
            <el-button class="btn" v-if="!edit" @click="() => edit = !edit">
              {{ button }}
            </el-button>
            <el-button class="btn" v-if="edit" @click="cancel">
              Cancel
            </el-button>
            <el-button class="btn" v-if="edit" @click="saveWarehousePricing">
              {{ button }}
            </el-button>
            <el-table
              :data="tableData"
              v-loading="!ready"
              empty-text="No Pricing set"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                property="range"
                label="Size Matrix"
              >
              </el-table-column>
              <el-table-column
                property="AA"
                label="A+"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.AA">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.AA }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                property="A"
                label="A"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.A">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.A }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                property="B"
                label="B"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.B">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.B }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                property="C"
                label="C"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.C">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.C }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="D"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" :disabled="true" v-if="scope.$index === 0" v-model="scope.row.D">
                  </el-input-number>
                  <el-input v-else size="small" :controls="false" :disabled="!edit" v-model="scope.row.D">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                property="S"
                label="S"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.S">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.S }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                property="X"
                label="X"
                width="150"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!edit" v-model="scope.row.X">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.X }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Office" value="office">
            <el-button class="btn" v-if="!editOffice" @click="() => editOffice = !editOffice">
              {{ button }}
            </el-button>
            <el-button class="btn" v-if="editOffice" @click="cancelOffice">
              Cancel
            </el-button>
            <el-button class="btn" v-if="editOffice" @click="saveOfficePricing">
              {{ button }}
            </el-button>
            <el-table
              :data="officeTableData"
              v-loading="!ready"
              empty-text="No Pricing set"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                property="range"
                label="Size Matrix"
              >
              </el-table-column>
              <el-table-column
                property="A"
                label="A"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!editOffice" v-model="scope.row.A">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.A }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="B"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" :disabled="true" v-if="scope.$index === 0" v-model="scope.row.B">
                  </el-input-number>
                  <el-input-number v-else size="small" :controls="false" :disabled="!editOffice" v-model="scope.row.B">
                  </el-input-number>
                </template>
              </el-table-column>
              <!-- <el-table-column
                property="B"
                label="B"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!editOffice" v-model="scope.row.B">
                  </el-input-number>
                  <el-input-number v-else size="small" :controls="false" :disabled="!editOffice" v-model="scope.row.B">
                  </el-input-number>
                </template>
              </el-table-column> -->
              <el-table-column
                property="C"
                label="C"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :max="10" v-if="scope.$index === 0" :disabled="!editOffice" v-model="scope.row.C">
                  </el-input-number>
                  <div v-else>
                    {{ scope.row.C }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Parking" value="parking">
            <el-button class="btn" v-if="!editParking" @click="() => editParking = !editParking">
              {{ button }}
            </el-button>
            <el-button class="btn" v-if="editParking" @click="cancelParking">
              Cancel
            </el-button>
            <el-button class="btn" v-if="editParking" @click="saveParkingPricing">
              {{ button }}
            </el-button>
            <el-table
              :data="parkingTableData"
              v-loading="!ready"
              empty-text="No Pricing set"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="P"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :disabled="!editParking" v-model="scope.row.P">
                    </el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                label="PL"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :disabled="!editParking" v-model="scope.row.PL">
                    </el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                label="PT"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :disabled="!editParking" v-model="scope.row.PT">
                    </el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                label="PR"
              >
                <template slot-scope="scope">
                  <el-input-number size="small" :controls="false" :min="0" :disabled="!editParking" v-model="scope.row.PR">
                    </el-input-number>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane name="facilities" label="Configure Multi Locations">
        <el-button class="btn" @click="openDialog">
          Save
        </el-button>
        <el-row class="el-row" :gutter="20">
          <el-col class="el-col" :span="8">
            <el-select v-model="value1" multiple placeholder="Select">
              <el-option
                v-for="item in facilities"
                :key="item._id"
                :label="item.title"
                :value="item._id">
              </el-option>
            </el-select>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for A+ Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="AAPercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for A Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="APercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for B Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="BPercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for C Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="CPercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for S Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="SPercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
          <el-col class="el-col" :span="8">
            <div class="grid-content bg-purple">
            <el-card>
              <div slot="header" class="clearfix">
                <span>Increase Price for X Quality Units in %</span>
              </div>
              <el-input-number :disabled="value1.length === 0" :min="0" :max="100" v-model="XPercentage"></el-input-number>
            </el-card>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane name="stillFull" label="Still Full">
          <el-card shadow="never" v-loading="loading">
            <el-form label-width="250px">
              <el-form-item label="Enable Still Full Pricing">
                  <el-switch
                    v-model="enableStillFullPrice"
                    active-text="Still Full Pricing On"
                    @change="saveStillFullPrice"
                  />
              </el-form-item>
              <el-form-item label="Still Full Pricing in percentage">
                  <el-input-number
                    :disabled="!enableStillFullPrice"
                    v-model="stillFullPercentage"
                    :precision="2"
                    :step="0.1"
                    :min="0.1"
                    :max="25"
                    @change="saveStillFullPrice"
                  />
              </el-form-item>
          </el-form>
          </el-card>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import axios from 'axios';
import { matrix, officeMatrix } from '../utils/sizeMatrix';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'OrgPricing',
  props: {
    pricing: { type: Object, default: () => {} },
    facility: { type: String, default: null },
  },
  async mounted() {
    this.abortController = new AbortController();
    this.loading = true;
    await this.loadData();
    this.enableStillFullPrice = this.selectedFacility.stillFullFlag;
    this.stillFullPercentage = this.selectedFacility.stillFullPrice;
    this.loading = false;
  },
  watch: {
    async facility() {
      if (this.loading) {
        this.abortController.abort();
        this.abortController = new AbortController();
      }
      this.ready = false;
      this.loading = true;
      this.selectedFacility = await this.getFacility();
      this.enableStillFullPrice = this.selectedFacility.stillFullFlag;
      this.stillFullPercentage = this.selectedFacility.stillFullPrice;
      console.log(this.selectedFacility);

      this.loading = false;
      if (!this.selectedFacility.pricing || !this.selectedFacility.pricing.qualityPricing) {
        this.selectedFacility.pricing = {
          qualityPricing: {
            A: 0,
            AA: 0,
            B: 0,
            D: 1,
            C: 0,
            S: 0,
            X: 0,
          },
          currency: this.selectedFacility.pricing.currency,
        };
      }

      if (!this.selectedFacility.officePricing) {
        this.selectedFacility.officePricing = {
          qualityPricing: {
            A: 0,
            B: 0,
            C: 0,
          },
          currency: this.selectedFacility.pricing.currency,
        };
      }

      if (!this.selectedFacility.parkingPricing) {
        this.selectedFacility.parkingPricing = {
          qualityPricing: {
            P: 0,
            PL: 0,
            PT: 0,
            PR: 0,
          },
          currency: this.selectedFacility.pricing.currency,
        };
      }

      if (this.selectedFacility.tax) {
        this.setupTaxRate = this.selectedFacility.tax.setupTaxRate;
        this.rentTaxRate = this.selectedFacility.tax.rentTaxRate;
      } else {
        this.setupTaxRate = 0;
        this.rentTaxRate = 0;
      }
      await this.prepareTableData();
      await this.prepareOfficeTableData();
      await this.prepareParkingTableData();
      this.ready = true;
    },
  },
  computed: {
    button() {
      if (this.edit || this.editOffice || this.editParking) {
        return 'Save';
      }
      return 'Edit';
    },
  },
  data() {
    return {
      enableStillFullPrice: false,
      abortController:null,
      stillFullPercentage: 0.1,
      price: null,
      setupFee: null,
      rentTaxRate: 0,
      setupTaxRate: 0,
      currency: 'usd',
      edit: false,
      editOffice: false,
      editParking: false,
      facilities: [],
      activeTab: 'facility',
      pricingTab: 'warehouse',
      ready: false,
      loading: true,
      selectedFacility: {},
      value1: [],
      qualityPricing: {
        AA: 0,
        A: 0,
        B: 0,
        C: 0,
        D: 1,
        S: 0,
        X: 0,
      },
      officeQualityPricing: {
        A: 0,
        B: 0,
        C: 0,
      },
      parkingQualityPricing: {
        P: 0,
        PL: 0,
        PT: 0,
        PR: 0,
      },
      AAPercentage: 0,
      APercentage: 0,
      BPercentage: 0,
      CPercentage: 0,
      SPercentage: 0,
      XPercentage: 0,
      tableData: [],
      officeTableData: [],
      parkingTableData: [],
      matrix,
      officeMatrix,
    };
  },
  methods: {
    async loadData() {
      this.ready = false;
      try {

        this.facilities = await this.getFacilities();
        this.selectedFacility = await this.getFacility();
        if (!this.selectedFacility.pricing || !this.selectedFacility.pricing.qualityPricing) {
          this.selectedFacility.pricing = {
            qualityPricing: {
              A: 0,
              AA: 0,
              B: 0,
              C: 0,
              D: 1,
              S: 0,
              X: 0,
            },
            currency: this.selectedFacility.pricing.currency,
          };
        }
  
        if (!this.selectedFacility.officePricing) {
          this.selectedFacility.officePricing = {
            qualityPricing: {
              A: 0,
              B: 0,
              C: 0,
            },
            currency: this.selectedFacility.pricing.currency,
          };
        }
  
        if (!this.selectedFacility.parkingPricing) {
          this.selectedFacility.parkingPricing = {
            qualityPricing: {
              P: 0,
              PL: 0,
              PT: 0,
              PR: 0,
            },
            currency: this.selectedFacility.pricing.currency,
          };
        }
  
        if (this.selectedFacility.tax) {
          this.setupTaxRate = this.selectedFacility.tax.setupTaxRate;
          this.rentTaxRate = this.selectedFacility.tax.rentTaxRate;
        } else {
          this.setupTaxRate = 0;
          this.rentTaxRate = 0;
        }
        this.prepareTableData();
        this.prepareOfficeTableData();
        this.prepareParkingTableData();
      } catch ( er ) {
        console.log(er);
      }
      this.ready = true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row';
      }
      return '';
    },
    async getFacilities() {
      const response = await axios.get(`${ADMIN_API_BASE}/facilities`, {
        signal: this.abortController.signal,
        params: {
          limit: 35,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      return response.data;
    },
    prepareTableData() {
      this.tableData = [];
      const tiers = this.selectedFacility.pricing.qualityPricing;
      tiers.D = 1;
      tiers.range = '0-1';
      this.tableData.push(tiers);
      this.selectedFacility.pricing.dTier = this.matrix.map((item, index) => ({
        range: item.label,
        rate: this.selectedFacility.pricing.dTier && this.selectedFacility.pricing.dTier[index]
          ? this.selectedFacility.pricing.dTier[index].rate : 0,
      }));

      this.selectedFacility.pricing.dTier.forEach((size) => {
        const obj = {
          // ...this.selectedFacility.pricing.qualityPricing,
          AA: (size.rate * this.selectedFacility.pricing.qualityPricing.AA).toFixed(2),
          A: (size.rate * this.selectedFacility.pricing.qualityPricing.A).toFixed(2),
          B: (size.rate * this.selectedFacility.pricing.qualityPricing.B).toFixed(2),
          C: (size.rate * this.selectedFacility.pricing.qualityPricing.C).toFixed(2),
          D: size.rate,
          S: (size.rate * this.selectedFacility.pricing.qualityPricing.S).toFixed(2),
          X: (size.rate * this.selectedFacility.pricing.qualityPricing.X).toFixed(2),
          range: size.range,
        };
        this.tableData.push(obj);
      });
    },
    async cancel() {
      this.edit = false;

      await this.loadData();
      this.$message.warning({
        message: 'No change is made',
      });
    },
    async cancelOffice() {
      this.editOffice = false;

      await this.loadData();
      this.$message.warning({
        message: 'No change is made',
      });
    },
    async cancelParking() {
      this.editOffice = false;

      await this.loadData();
      this.$message.warning({
        message: 'No change is made',
      });
    },
    prepareOfficeTableData() {
      this.officeTableData = [];
      const tiers = this.selectedFacility.officePricing.qualityPricing;
      tiers.B = 1;
      tiers.range = '0-1';
      this.officeTableData.push(tiers);
      this.selectedFacility.officePricing.dTier = this.officeMatrix.map((item, index) => ({
        range: item.label,
        rate: this.selectedFacility.officePricing
        && this.selectedFacility.officePricing.dTier[index]
          ? this.selectedFacility.officePricing.dTier[index].rate : 0,
      }));

      this.selectedFacility.officePricing.dTier.forEach((size) => {
        const obj = {
          // ...this.selectedFacility.pricing.qualityPricing,
          A: (size.rate * this.selectedFacility.officePricing.qualityPricing.A).toFixed(2),
          B: size.rate,
          C: (size.rate * this.selectedFacility.officePricing.qualityPricing.C).toFixed(2),
          range: size.range,
        };
        this.officeTableData.push(obj);
      });
    },
    prepareParkingTableData() {
      this.parkingTableData = [];
      const tiers = this.selectedFacility.parkingPricing.qualityPricing;
      this.parkingTableData.push(tiers);
    },
    async getFacility() {
      const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        signal: this.abortController.signal,
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.currency = response.data.pricing.currency;
      return response.data;
    },
    async savePricing(table, type, priceColumn) {
      const dTier = table.map(item => ({ range: item.range, rate: Number(item[priceColumn]) }));
      dTier.shift();

      await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        [type]: {
          qualityPricing: { ...table[0] },
          dTier,
          currency: this.currency,
        },
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.$message.success({
        message: 'Update completed',
      });
    },
    async saveWarehousePricing() {
      this.edit = false;
      try {
        await this.savePricing(this.tableData, 'pricing', 'D');
        await this.loadData();
      } catch (error) {
        this.$message({
          type: 'info',
          message: error.response.data,
        });
      }
    },
    async saveOfficePricing() {
      try {
        this.editOffice = false;
        await this.savePricing(this.officeTableData, 'officePricing', 'B');
        await this.loadData();
      } catch (err) {
        this.$message({
          type: 'info',
          message: err.response.data,
        });
      }
    },
    async saveParkingPricing() {
      this.editParking = false;
      try {
        await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          parkingPricing: {
            qualityPricing: { ...this.parkingTableData[0] },
            currency: this.currency,
          },
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.$message({
          type: 'success',
          message: 'Update completed',
        });
        await this.loadData();
      } catch (error) {
        this.$message({
          type: 'info',
          message: error.response.data,
        });
      }
    },
    openDialog() {
      // this.value1 = [];
      this.ready = false;
      this.$confirm('This will reflect for all the selected facilities units and will affect for all future sales.', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
      }).then(async () => {
        for (const item of this.value1) {
          console.log(item);
          const [filteredFacility] = this.facilities.filter((fac) => {
            if (fac._id === item) {
              return fac;
            }
          });
          if (filteredFacility) {
            await axios.post(`${ADMIN_API_BASE}/facilities/${item}`, {
              pricing: {
                qualityPricing: {
                  // eslint-disable-next-line no-nested-ternary
                  A: this.APercentage > 0 ?
                    filteredFacility.pricing.qualityPricing.A + (filteredFacility.pricing.qualityPricing.A * (this.APercentage / 100))
                    : filteredFacility.pricing.qualityPricing.A ? filteredFacility.pricing.qualityPricing.A : 0,
                  // eslint-disable-next-line no-nested-ternary
                  AA: this.AAPercentage > 0 ?
                    filteredFacility.pricing.qualityPricing.AA + (filteredFacility.pricing.qualityPricing.AA * (this.AAPercentage / 100))
                    : filteredFacility.pricing.qualityPricing.AA ? filteredFacility.pricing.qualityPricing.AA : 0,
                  // eslint-disable-next-line no-nested-ternary
                  B: this.BPercentage > 0 ?
                    filteredFacility.pricing.qualityPricing.B + (filteredFacility.pricing.qualityPricing.B * (this.BPercentage / 100))
                    : filteredFacility.pricing.qualityPricing.B ? filteredFacility.pricing.qualityPricing.B : 0,
                  // eslint-disable-next-line no-nested-ternary
                  C: this.CPercentage > 0 ?
                    filteredFacility.pricing.qualityPricing.C + (filteredFacility.pricing.qualityPricing.C * (this.CPercentage / 100))
                    : filteredFacility.pricing.qualityPricing.C ? filteredFacility.pricing.qualityPricing.C : 0,
                  // eslint-disable-next-line no-nested-ternary
                  S: this.SPercentage > 0 ? filteredFacility.pricing.qualityPricing.S + (filteredFacility.pricing.qualityPricing.S * (this.SPercentage / 100))
                    : filteredFacility.pricing.qualityPricing.S ? filteredFacility.pricing.qualityPricing.S : 0,
                  // eslint-disable-next-line no-nested-ternary
                  X: this.XPercentage > 0 ?
                    filteredFacility.pricing.qualityPricing.X + (filteredFacility.pricing.qualityPricing.X * (this.XPercentage / 100))
                    : filteredFacility.pricing.qualityPricing.X ? filteredFacility.pricing.qualityPricing.X : 0,
                },
              },
              tax: {
                rentTaxRate: this.rentTaxRate,
                setupTaxRate: this.setupTaxRate,
              },
            }, {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            });
          }
          this.facilities = await this.getFacilities();
          this.selectedFacility = await this.getFacility();
          this.AAPercentage = 0;
          this.APercentage = 0;
          this.BPercentage = 0;
          this.CPercentage = 0;
          this.SPercentage = 0;
          this.XPercentage = 0;
          this.ready = true;
        }
        this.$message({
          type: 'success',
          message: 'Update completed',
        });
        this.value1 = [];
      }).catch((error) => {
        this.$message({
          type: 'info',
          message: error.response.data,
        });
      });
    },
    async saveStillFullPrice() {
      this.loading = true;
      const result = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
        stillFullPrice: this.stillFullPercentage,
        stillFullFlag: this.enableStillFullPrice,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.enableStillFullPrice = result.data.stillFullFlag;
      this.stillFullPercentage = result.data.stillFullPrice;

      this.loading = false;
      this.$message.success({
        message: this.enableStillFullPrice ? 'Still Full price updated successfully' : 'Still Full price disabled successfully',
      });
    },
  },
};
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
  }

.el-col {
  margin-bottom: 20px;
}

.btn {
  margin-bottom: 20px;
}

.el-table__row .warning-row {
  background: rgb(195, 137, 28) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/OrgPricing.vue